import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var SerachResultsInfo = styled.div.withConfig({
  displayName: "ResultsInfo__SerachResultsInfo",
  componentId: "wyu4pk-0"
})(["padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;border-bottom:1px solid #ddd;"], spacing.base / 2, spacing.base, spacing.base / 2, spacing.base);

var ResultsInfo = function ResultsInfo(_ref) {
  var searchResults = _ref.searchResults,
      totalResults = _ref.totalResults;
  return React.createElement(SerachResultsInfo, null, React.createElement("span", null, "Showing ", searchResults && searchResults.length, " of ", totalResults, " results"));
};

export default ResultsInfo;